module.exports = __webpack_public_path__ + "static/img/base-con-img.82bfefd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/base-con-img.svg
// module id = IXHV
// module chunks = 0